/* eslint-disable max-len */
/**
 * English translations.
 */
export default {
  ACTION: {
    LINK_COPY: 'Copy'
  },
  ERROR: {},
  HEADER: {
    NAME: 'Name'
  },
  LABEL: {
    FILTER_MONTH_APR: 'April',
    FILTER_MONTH_AUG: 'August',
    FILTER_MONTH_DEC: 'December',
    FILTER_MONTH_FEB: 'February',
    FILTER_MONTH_JAN: 'January',
    FILTER_MONTH_JUL: 'July',
    FILTER_MONTH_JUN: 'June',
    FILTER_MONTH_MAR: 'March',
    FILTER_MONTH_MAY: 'May',
    FILTER_MONTH_NOV: 'November',
    FILTER_MONTH_OCT: 'October',
    FILTER_MONTH_SEP: 'September',
    GENERATE_HASHTAG: 'Generate hashtag',
    GENERATE_LINK: 'Generate link',
    GENERATED_HASHTAG: 'Generated Hashtag',
    GENERATED_LINK: 'Generated Link',
    MONTH: 'Month',
    NAME: 'Name',
    YEAR: 'Year'
  },
  SENTENCE: {
    NO_ROWS_PRODUCTS: 'No Products',
    NO_ROWS_PRODUCTS_DESCRIPTION: 'Please change your search criteria'
  },
  SUCCESS: {
    HASHTAG_COPIED: 'Hashtag copied',
    LINK_COPIED: 'Link copied'
  },
  TOOLTIP: {
    MONTH: 'Month',
    NAME: 'Name',
    YEAR: 'Year'
  }
};
